import { VueEditor } from 'vue2-editor';
import OnlyNumber from '@/app/helpers/OnlyNumber';
import GETWarehouse from '@/app/helpers/GETWarehouse';
import { APIRequest, APIRequestUpload } from '@/app/services/APIRequest';
import compileSchema from '@/app/schema/Compile';
import Schema from '@/app/schema/Schema';
import FocusRef from '@/app/helpers/ForcusRef';
import store from '@/app/vuex/store';
import Navbar from '@/views/components/layouts/Navbar.vue';

export default {
  props: {
    idEdit: String
  },
  components: {
    VueEditor,
    Navbar
  },
  data: () => ({
    itemsSelectCategoryProduct: [],
    itemsSelectWarehouse: [],
    blobURL: null,
    valueInput: {
      productType: null,
      productName: null,
      productCode: null,
      productBarcode: null,
      productImage: null,
      productCategory: null,
      productBrand: null,
      productWeight: null,
      productLong: null,
      productWide: null,
      productHeight: null,
      productSubDetail: null,
      productDetail: null,
      productTrack: null,
      productStatusWebCatalog: false,
      productWarehouse: null,
      productCost: null,
      productPrice: null,
      productQTY: null,
      productMinimumInventory: null
    },

    rule: {
      productName: [
        value => !!value || 'กรุณากรอกชื่อสินค้า',
        value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร',
        value => (value && value.length <= 150) || 'ห้ามเกิน 150 ตัวอักษร'
      ],
      // productCode: [
      //   value => !!value || 'กรุณากรอกรหัสสินค้า',
      //   value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร',
      //   value => (value && value.length <= 20) || 'ห้ามเกิน 20 ตัวอักษร'
      // ],
      productBarcode: [
        value => !!value || 'กรุณากรอกบาร์โค้ด',
        value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร',
        value => (value && value.length <= 20) || 'ห้ามเกิน 20 ตัวอักษร'
      ],
      productCategory: [
        value => !!value || 'กรุณาเลือกหมวดหมู่สินค้า'
      ],
      productBrand: [
        value => !!value || 'กรุณากรอกแบรนด์',
        value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร',
        value => (value && value.length <= 150) || 'ห้ามเกิน 150 ตัวอักษร'
      ],
      productWeight: [
        value => !!value || 'กรุณากรอกน้ำหนัก',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 กรัม',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value < 99999) || 'ห้ามเกิน 99999 กรัม'
      ],
      productLong: [
        value => !!value || 'กรุณากรอกความยาว',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 มม.',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value < 99999) || 'ห้ามเกิน 99999 มม.'
      ],
      productWide: [
        value => !!value || 'กรุณากรอกความกว้าง',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 มม.',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value < 99999) || 'ห้ามเกิน 99999 มม.'
      ],
      productHeight: [
        value => !!value || 'กรุณากรอกความสูง',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 มม.',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value < 99999) || 'ห้ามเกิน 99999 มม.'
      ],
      productSubDetail: [
        value => !!value || 'กรุณากรอกรายละเอียดย่อย',
        value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร',
        value => (value && value.length <= 150) || 'ห้ามเกิน 150 ตัวอักษร'
      ],
      productDetail: [
        value => !!value || 'กรุณากรอกรายละเอียด',
        value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร'
      ],
      productTrack: [
        value => !!value || 'กรุณาเลือกแท๊กสินค้า',
        value => (value && value.length >= 3) || 'ขั้นต่ำ 3 ตัวอักษร',
        value => (value && value.length <= 150) || 'ห้ามเกิน 150 ตัวอักษร'
      ],
      productWarehouse: [
        value => !!value || 'กรุณาเลือกคลังสินค้า'
      ],
      productCost: [
        value => !!value || 'กรุณากรอกต้นทุน',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 บาท',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value < 9999999999) || 'ห้ามเกิน 9,999,999,999 บาท'
      ],
      productPrice: [
        value => !!value || 'กรุณากรอกราคาต่อหน่วย',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 บาท',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value < 9999999999) || 'ห้ามเกิน 9,999,999,999 บาท'
      ],
      productQTY: [
        value => !!value || 'กรุณากรอกจำนวนสินค้า',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 ชิ้น',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value < 9999999999) || 'ห้ามเกิน 9,999,999,999 ชิ้น'
      ],
      productMinimumInventory: [
        value => !!value || 'กรุณากรอกสินค้าคงคลังขั้นต่ำ',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value >= 1) || 'ขั้นต่ำ 1 ชิ้น',
        // eslint-disable-next-line no-restricted-globals
        value => (!isNaN(parseFloat(value)) && value < 9999999999) || 'ห้ามเกิน 9,999,999,999 ชิ้น'
      ]
    },
    itemsTrackProduct: [],
    itemsWarehouse: [],
    dataEdit: null
  }),
  mounted(){
    this.getCategory();
    this.getWarehouse();

    if (this.$route && this.$route.name === 'ProductEdit' && this.$props && this.$props.idEdit){
      this.getDataEdit();
    }
  },
  methods: {
    getWarehouse(){
      GETWarehouse()
        .then(response => {
          if (response && response.code === 10 && response.result){
            this.itemsSelectWarehouse = response.result;
          }
        });
    },

    getCategory(){
      APIRequest({
        method: 'GET',
        url: '/category/list-sub-category',
        auth: true
      }).then(response => {
        if (response && response.data.code === 10 && response.data.result){
          this.itemsSelectCategoryProduct = response.data.result;
        }
      }).catch(error => {
        console.log(error);
      });
    },

    handleInputPhoneNumber($event){
      OnlyNumber($event);
    },

    previewFiles(event){
      this.valueInput.productImage = event;
      this.blobURL = URL.createObjectURL(event);
    },

    handleInsertData(){
      const data = {
        productName: this.valueInput.productName || null,
        // productCode: this.valueInput.productCode || null,
        productImage: this.valueInput.productImage ? this.valueInput.productImage.name : null,
        // eslint-disable-next-line dot-notation
        productCategoryID: this.valueInput.productCategory ? this.valueInput.productCategory['_id'] : null,
        productBrand: this.valueInput.productBrand || null,
        productWeight: this.valueInput.productWeight || null,
        productLong: this.valueInput.productLong || null,
        productWide: this.valueInput.productWide || null,
        productHeight: this.valueInput.productHeight || null,
        productSubDetail: this.valueInput.productSubDetail || null,
        productDetail: this.valueInput.productDetail || null,
        productCost: this.valueInput.productCost || null,
        productPrice: this.valueInput.productPrice || null,
        productQTY: this.valueInput.productQTY || null,
        productMinimumInventory: this.valueInput.productMinimumInventory || null
      };

      const compile = compileSchema(data, Schema.Product);
      if (compile){
        const forcus = FocusRef(compile);
        if (forcus){
          this.$refs[forcus].focus();
        }
      }

      if (compile.pass === true){
        store.dispatch('loading/setLoading', true);
        const formData = new FormData();
        formData.append('photos', this.valueInput.productImage);

        APIRequestUpload({
          method: 'POST',
          url: '/upload/img',
          data: formData,
          auth: true
        }).then(response => {
          if (response && response.data.code === 10){
            data.productImage = response.data.url;

            // const finalData = {
            //   productName: this.valueInput.productName,
            //   productCode: this.valueInput.productCode,
            //   productImage: response.data.url,
            //   // eslint-disable-next-line dot-notation
            //   productCategoryID: this.valueInput.productCategory ? this.valueInput.productCategory['_id'] : null,
            //   productCategoryName: this.valueInput.productCategory,
            //   productBrand: this.valueInput.productBrand,
            //   productWeight: this.valueInput.productWeight,
            //   productLong: this.valueInput.productLong,
            //   productWide: this.valueInput.productWide,
            //   productHeight: this.valueInput.productHeight,
            //   productSubDetail: this.valueInput.productSubDetail,
            //   productDetail: this.valueInput.productDetail,
            //   productCost: this.valueInput.productCost,
            //   productPrice: this.valueInput.productPrice,
            //   productQTY: this.valueInput.productQTY,
            //   productMinimumInventory: this.valueInput.productMinimumInventory
            // };

            store.dispatch('loading/setLoading', true);
            APIRequest({
              method: 'POST',
              url: '/product/',
              data,
              auth: true
            }).then(response2 => {
              if (response2 && response2.data.code === 0){
                this.$router.push({ name: 'Product' });
              }
              store.dispatch('loading/setLoading', false);
            }).catch(error => {
              console.log(error);
              store.dispatch('loading/setLoading', false);
            });
          }
        }).catch(error => {
          console.log(error);
          store.dispatch('loading/setLoading', false);
        });
      }
    },

    getDataEdit(){
      store.dispatch('loading/setLoading', true);
      const data = {
        id: this.$props ? this.$props.idEdit : ''
      };
      APIRequest({
        method: 'POST',
        url: '/product/get-product-query-by-id',
        data,
        auth: true
      }).then(response => {
        if (response && response.data.code === 10 && response.data.result){
          const { result } = response.data;
          this.dataEdit = result;
          this.valueInput.productName = result.name;
          this.valueInput.productCode = result.code;
          this.blobURL = result.image;
          this.valueInput.productCategory = result.categoryID;
          this.valueInput.productBrand = result.brand;
          this.valueInput.productWeight = result.weight;
          this.valueInput.productLong = result.long;
          this.valueInput.productWide = result.wide;
          this.valueInput.productHeight = result.height;
          this.valueInput.productSubDetail = result.subDetail;
          this.valueInput.productDetail = result.detail;
          this.valueInput.productCost = result.cost;
          this.valueInput.productPrice = result.price;
          this.valueInput.productQTY = result.qty;
          this.valueInput.productMinimumInventory = result.minimumInventory;
        }
        store.dispatch('loading/setLoading', false);
      }).catch(error => {
        console.log(error);
        store.dispatch('loading/setLoading', false);
      });
    },

    handleEditData(){
      const data = {
        id: this.$props ? this.$props.idEdit : '',
        productName: this.valueInput.productName || null,
        productImage: this.valueInput.productImage ? this.valueInput.productImage.name : this.dataEdit.image,
        // eslint-disable-next-line dot-notation
        productCategoryID: this.valueInput.productCategory['_id'] ? this.valueInput.productCategory['_id'] : this.valueInput.productCategory,
        productBrand: this.valueInput.productBrand || null,
        productWeight: this.valueInput.productWeight || null,
        productLong: this.valueInput.productLong || null,
        productWide: this.valueInput.productWide || null,
        productHeight: this.valueInput.productHeight || null,
        productSubDetail: this.valueInput.productSubDetail || null,
        productDetail: this.valueInput.productDetail || null,
        productCost: this.valueInput.productCost || null,
        productPrice: this.valueInput.productPrice || null,
        productQTY: this.valueInput.productQTY || null,
        productMinimumInventory: this.valueInput.productMinimumInventory || null
      };

      const compile = compileSchema(data, Schema.Product);
      if (compile.pass === true){
        if (data.productImage !== this.dataEdit.image){
          const formData = new FormData();
          formData.append('photos', this.valueInput.productImage);
          store.dispatch('loading/setLoading', true);
          APIRequestUpload({
            method: 'POST',
            url: '/upload/img',
            data: formData,
            auth: true
          }).then(response => {
            if (response && response.data.code === 10){
              data.productImage = response.data.url;

              APIRequest({
                method: 'PUT',
                url: '/product/',
                data,
                auth: true
              }).then(response2 => {
                console.log(response2);
                if (response2 && response2.data && response2.data.code === 0){
                  this.$router.push({ name: 'Product' });
                  store.dispatch('loading/setLoading', false);
                }
              }).catch(error => {
                console.log(error);
                store.dispatch('loading/setLoading', false);
              });
            }
          }).catch(error => {
            console.log(error);
            store.dispatch('loading/setLoading', false);
          });
        } else {
          console.log('else edit new data : ', data);
          store.dispatch('loading/setLoading', true);
          APIRequest({
            method: 'PUT',
            url: '/product/',
            data,
            auth: true
          }).then(response => {
            if (response && response.data && response.data.code === 0){
              this.$router.push({ name: 'Product' });
            }
            store.dispatch('loading/setLoading', false);
          }).catch(error => {
            console.log(error);
            store.dispatch('loading/setLoading', false);
          });
        }
      }
    }

  }

};
